/* eslint-disable */
import { i18n } from "../i18n";

export const declension = (
  oneNominative: string,
  severalGenitive: string,
  severalNominative: string,
  number: number,
) => {
  if (i18n.language === "en") {
    return number === 1 ? oneNominative : severalGenitive;
  }

  number = number % 100;

  return number <= 14 && number >= 11
    ? severalGenitive
    : (number %= 10) < 5
    ? number > 2
      ? severalNominative
      : number === 1
      ? oneNominative
      : number === 0
      ? severalGenitive
      : severalNominative
    : severalGenitive;
};
